<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData">
      <template v-slot:slotTableData="update">
        <!--语言说明-->
        <slotTable :update="update"></slotTable>
      </template>
    </UPDATE>
    <slotRule v-if="isSlotRule" :isShow="isSlotRule" :slotData="ruleData" @changeSlotRule="changeSlotRule"></slotRule>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Url from '@/views/crs/util/url'
import UPDATE from '@/components/page/update'
import slotTable from '@/views/crs/quantitytask/activity/components/slotTable'
import slotRule from '@/views/crs/quantitytask/activity/components/slotRule'
import Qs from 'qs'

let typeArr = { 0: '抽獎', 1: '大富翁', 2: '過山車' }
let statsArr = { 0: '未開啟', 1: '開啟' }
let statusArr = { 0: '未激活', 1: '激活' }
let levelArr = { 'MIN': '迷你', 'STD': '标准', 'PLA': '铂金', 'ZER': '巴菲特' }
let slotTableData = {}

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE,
    slotTable,
    slotRule
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    initTask(row, type) {
      this.$axios.get(Url.quantityTask.limitTask + '?alias=' + DateUtil.getParamKey(this.$route.params)).then(res => {
        if (res.code == 0) {
          if (type == 0) {
            row.rule.limitTaskData = res.result
            this.isSlotRule = true
            this.ruleData = row
          } else {
            if (res.result && res.result.length > 0) {
              this.updateData.cols.find(function(e) {
                return e.field == 'rule'
              }).limitTaskData = res.result
            }
            if (row) {
              this.$refs.childUpdate.open(row)
            } else {
              this.$refs.childUpdate.open()
            }
          }
        } else {
          if (type == 0) {
            row.rule.limitTaskData = []
            this.isSlotRule = true
            this.ruleData = row
          } else {
            if (row) {
              this.$refs.childUpdate.open(row)
            } else {
              this.$refs.childUpdate.open()
            }
          }
        }
      })
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if (window.$t('common.add') == clickName || '增加' == clickName) {
        this.updateData.cols.find(function(e) {
          return e.field == 'type'
        }).readonly = false
        this.initTask()
      } else if ('列表显示隐藏' == clickName || window.$t('bt.hideOrNo') == clickName) {
        this.pageData.isShow = !this.pageData.isShow
      }
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        this.updateData.cols.find(function(e) {
          return e.field == 'type'
        }).readonly = true
        row.time = [row.startTime, row.endTime]
        row.activityStatus = row.activityStatus ? row.activityStatus.split(',') : ''
        row.userLevel = row.userLevel ? row.userLevel.split(',') : ''
        row.rule = JSON.parse(row.rule)
        this.initTask(row)
      } else if (clickName == 'delete') {
        this.dataChange(Url.quantityTask.activity.del, { id: row.id }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'status') {
        this.dataChange(Url.quantityTask.activity.status, {
          status: row.status,
          id: row.id,
          businessTypeAlias: DateUtil.getParamKey(this.$route.params)
        }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'checkRule') {
        row.rule = JSON.parse(row.rule)
        this.initTask(row, 0)
      }
    },
    changeSlotRule(val) {
      this.isSlotRule = val
    },
    submit(model) {
      model.values = JSON.stringify(model.values)
      model.startTime = model.time[0]
      model.endTime = model.time[1]
      delete model.time
      model.activityStatus = model.activityStatus.join(',')
      model.userLevel = model.userLevel.join(',')
      model.rule = JSON.stringify(model.rule)
      this.dataChange(Url.quantityTask.activity.edit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },

          {
            title: '類型',
            field: 'type',
            type: 2,
            optionList: typeArr,
            multiple: false
          },
          {
            title: '狀態',
            field: 'status',
            type: 2,
            optionList: statsArr,
            multiple: false
          },
          {
            title: window.$t('crs.quantityTask.startTime'),
            field: 'startTime',
            type: 5,
            format: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            title: window.$t('crs.quantityTask.endTime'),
            field: 'endTime',
            type: 5,
            format: 'yyyy-MM-dd HH:mm:ss'
          },
          { click: window.$t('common.search') },
          { click: window.$t('common.add'), auth: 'crs:activity:edit' },
          { click: '列表显示隐藏' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.activity.list,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          {
            title: window.$t('crs.quantityTask.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '创建人', field: 'cname' },
          {
            title: '活动開始时间', field: 'startTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '活动結束时间', field: 'endTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '活动名称', field: 'name' },
          { title: '活动ID', field: 'actId' },
          {
            title: '活动类型', field: 'type', render: (data, full) => {
              return typeArr[data]
            }
          },
          {
            title: '激活條件', field: 'activityStatus', render: (data, full) => {
              let tempData = data.split(',')
              for (const key in tempData) {
                data = data.replaceAll(key, statusArr[key])
              }
              return data
            }
          },
          { title: '账户级别', field: 'userLevel' },
          {
            title: window.$t('crs.quantityTask.status'), field: 'status', render: (data, full) => {
              return statsArr[data]
            }
          },
          {
            title: '规则', field: 'rule',
            btnClick: [
              {
                name: '查看规则',
                click: 'checkRule',
                type: 'primary'
              }
            ]
          },
          {
            title: window.$t('crs.bt.operation'),
            btnClick: [
              {
                name: window.$t('crs.quantityTask.taskStatus'),
                click: 'status',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'crs:activity:status'
              },
              {
                name: window.$t('crs.bt.edit'),
                click: 'update',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'crs:activity:edit'
              },
              {
                name: window.$t('crs.bt.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'crs:activity:del'
              }
            ]
          }
        ]
      },
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '活动名称', field: 'name', required: true },
          { title: '活动ID', field: 'actId', required: true },
          {
            title: '類型',
            field: 'type',
            type: 2,
            optionList: typeArr,
            multiple: false,
            required: true,
            isNumber: true
          },
          { title: '活动时间', field: 'time', type: 9, data: [], required: true },
          {
            title: '激活状态',
            field: 'activityStatus',
            type: 4,
            data: [],
            optionList: statusArr
          },
          {
            title: '账户级别',
            field: 'userLevel',
            type: 4,
            data: [],
            optionList: levelArr
          },
          {
            title: '条件组',
            field: 'rule',
            type: 10,
            slot: 'slotTableData',
            required: true,
            data: slotTableData,
            num: 0,
            limitTaskData: []
          }
        ]
      },
      ruleData: {},
      isSlotRule: false
    }
  }
}
</script>
